<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-top-6px padding-bottom-6px">

        <label class="margin-bottom-0px font-weight-normal margin-right-8px">{{DocTitle}}</label> <label class="margin-bottom-0px font-weight-normal">{{DocCaptureDate| date:'dd-MMM-yyyy'}}</label>

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="chatsd product-chart-wrapper product-chat-width2 agreement-chart-wrapper ps ps-auto padding-lrt " data-ps-id="dfsfsde">
        <div class="modal-body padding-tb">
          <div>
            <!--*ngIf="SelectedDocument"-->
            <div class="row gray">
              <div class="col-md-4 padding-l-0px margin-left-10px margin-top-10">

                <img [src]='DocFriendlyName' class="img-circle-65  border-radius-0px" width="auto" height="auto" />

              </div>





            </div>
          </div>
        </div>
      </div>
      <!--<div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
      </div>-->
    </div>
  </div>
</div>
